import _ from 'lodash';
import { Mutation } from '@apollo/client/react/components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { config } from '../../../../../config';
import ModalDraft from '../modal-move-draft';
import TypeTest from '../../../../../core/constants/testTypes';

import {
  ButtonInvite,
  ButtonRemove,
  Container,
  Detail,
  DetailFaceRecording,
  LinkedInUrl,
  LoadMore,
  LoadMoreContainer,
  OtherDetails,
  Tester,
  TesterName,
  ContainerSpace,
  ContainerParticipants,
  ButtonMoveDraft,
  UserInterviewsLinksContainer,
  UserInterviewsSegmentLinks,
  UserInterviewsLink,
} from './styles';

import CapResponsesModal from '../../cap-responses-modal';

import {
  APPROVE_TESTER,
  GET_TESTERS,
  REMOVE_TESTER,
} from '../../graphql';

const LIMIT = 5;

class InviteTesters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      isOpenModalDraft: false,
    };
  }

  handleMutationUpdate = (cache, { data: { approveTester, removeTester } }) => {
    const { testers: cachedTesters } = cache.readQuery({
      query: GET_TESTERS,
      variables: {
        approved: false,
        status: 'qualified',
        removed: false,
        projectId: this.props.project.id,
        limit: LIMIT,
        offset: 0,
      },
    });

    cache.writeQuery({
      query: GET_TESTERS,
      variables: {
        approved: false,
        status: 'qualified',
        removed: false,
        projectId: this.props.project.id,
        limit: LIMIT,
        offset: 0,
      },
      data: {
        testers: _.filter(
          cachedTesters,
          (cachedTester) => (
            cachedTester.id !== (approveTester ? approveTester.tester.id : removeTester.tester.id)
          ),
        ),
      },
    });
  }

  handleToggleModal = () => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  }

  handleOpenModalDraft = () => {
    this.setState({ isOpenModalDraft: true });
  }

  handleCloseModalDraft = () => {
    this.setState({ isOpenModalDraft: false });
  }

  render() {
    const {
      testers, project, showLoadMoreButton, refetch,
    } = this.props;
    const {
      createdBy,
      description,
      id: projectId,
      submittedAvailabilities,
      testType,
      receivedTests,
      sessionDuration,
      segments,
      faceRecording,
    } = project;

    return (
      <Container>
        <OtherDetails>
          Other Details:
        </OtherDetails>

        <Detail>
          Description:
          {' '}
          {description || (
            <b>No description provided</b>
          )}
        </Detail>

        {testType === TypeTest.MODERATED && (
          <Detail>
            {`Length: ${sessionDuration} minutes`}
          </Detail>
        )}

        <Detail>
          {`Created by: ${createdBy.profile.firstName} ${createdBy.profile.lastName}`}
        </Detail>
        <ContainerSpace>
          <div>
            {segments && segments.map((segment) => (
              <ContainerParticipants key={segment.id}>
                <Detail>
                  {`${segment.name} # Participants: ${segment.audienceParticipants}`}
                </Detail>
                <CapResponsesModal
                  label="Response Cap"
                  projectId={projectId}
                  number={segment.audienceParticipants}
                  segmentId={segment.id}
                  refetch={refetch}
                />
                {submittedAvailabilities && (
                  <Detail left={20}>
                    {`${config.REACT_APP_TESTER_PLATFORM_URI}/schedule?segment_id=${segment.id}&guest=true`}
                  </Detail>
                )}
              </ContainerParticipants>
            ))}
          </div>
          <div>
            <ButtonMoveDraft onClick={() => this.props.history.push(`/manage-testers?project_id=${project.id}`)}>
              <Icon name="search" />
              Find Testers
            </ButtonMoveDraft>
            {receivedTests === 0 && (
              <ButtonMoveDraft onClick={this.handleOpenModalDraft}>
                Move to draft
              </ButtonMoveDraft>
            )}
            {this.state.isOpenModalDraft && (
              <ModalDraft
                projectId={project.id}
                onClose={this.handleCloseModalDraft}
                refetch={refetch}
              />
            )}
          </div>
          <Link
            to={{
              pathname: `${config.REACT_APP_COMPANY_PLATFORM_URI}/projects/${project.id}/study`,
            }}
            target="_blank"
          >
            View study info
          </Link>
        </ContainerSpace>

        {testType === 'unmoderated' && (
          <DetailFaceRecording>
            {`Face recording: ${faceRecording ? 'ON' : 'OFF'}`}
          </DetailFaceRecording>
        )}

        <UserInterviewsLinksContainer>
          Link to testing provider:
          {segments.map((segment, index) => {
            if (!segment.userInterviewsProjectUrl) return <></>;
            return (
              <UserInterviewsSegmentLinks>
                {`Segment ${index + 1}: `}
                <UserInterviewsLink href={segment.userInterviewsProjectUrl} target="_blank">
                  {segment.userInterviewsProjectUrl}
                </UserInterviewsLink>
              </UserInterviewsSegmentLinks>
            );
          })}
        </UserInterviewsLinksContainer>

        {testers && testers.map((tester) => {
          const linkedinUrl = _.get(tester.user.profile, 'linkedinFields.linkedinUrl');

          return (
            <Tester key={tester.id}>
              <TesterName>
                <div>{`${tester.user.profile.firstName} ${tester.user.profile.lastName}`}</div>
                {testType === 'moderated' && <div>{`(${tester.user.email})`}</div>}
              </TesterName>

              <Mutation
                mutation={REMOVE_TESTER}
                update={this.handleMutationUpdate}
                onCompleted={refetch}
              >
                {(removeTester, { loading }) => (
                  <ButtonRemove
                    loading={loading}
                    onClick={() => {
                      removeTester({ variables: { id: tester.id } });
                    }}
                  >
                    Remove
                  </ButtonRemove>
                )}
              </Mutation>

              <Mutation
                mutation={APPROVE_TESTER}
                update={this.handleMutationUpdate}
                onCompleted={refetch}
              >
                {(approveTester, { loading }) => (
                  <ButtonInvite
                    loading={loading}
                    onClick={() => {
                      approveTester({ variables: { id: tester.id } });
                    }}
                  >
                    {testType === 'moderated' ? 'Select' : 'Invite'}
                  </ButtonInvite>
                )}
              </Mutation>

              {linkedinUrl
                && (
                  <LinkedInUrl
                    target="_blank"
                    href={linkedinUrl}
                  >
                    LinkedIn Profile
                  </LinkedInUrl>
                )}
            </Tester>
          );
        })}

        {showLoadMoreButton && (
          <LoadMoreContainer>
            <LoadMore onClick={this.props.onClickLoadMore}>Show more testers</LoadMore>
          </LoadMoreContainer>
        )}
      </Container>
    );
  }
}

InviteTesters.propTypes = {
  onClickLoadMore: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  project: PropTypes.shape({
    createdBy: PropTypes.shape({
      profile: PropTypes.shape({
        lastName: PropTypes.string,
        firstName: PropTypes.string,
      }),
    }),
    description: PropTypes.string,
    id: PropTypes.string,
    submittedAvailabilities: PropTypes.bool,
    testType: PropTypes.string,
    receivedTests: PropTypes.number,
    sessionDuration: PropTypes.number,
    faceRecording: PropTypes.bool,
    segments: PropTypes.arrayOf(PropTypes.shape({
      audienceParticipants: PropTypes.number,
      id: PropTypes.string,
      name: PropTypes.string,
      userInterviewsProjectUrl: PropTypes.string,
    })),
  }).isRequired,
  showLoadMoreButton: PropTypes.bool.isRequired,
  testers: PropTypes.arrayOf(PropTypes.shape({
    user: PropTypes.shape({
      profile: PropTypes.shape({
        lastName: PropTypes.string,
        firstName: PropTypes.string,
      }),
    }),
    map: PropTypes.func,
  })).isRequired,
  refetch: PropTypes.func.isRequired,
};

export default withRouter(InviteTesters);
